/* NOTE: Once one app moves to unified UI components, we don't need this wrapper */

import React, { useMemo } from 'react'
import type { IDropDownProps, IDropDownData } from '../DropDown/DropDown'
import type { LockedInfo } from '../../../store'
import type { SupportAccount, Tsg } from '@sparky/framework'
import { FED_HIGH_REGION, FED_MOD_REGION } from '../../../constants'

import CSPDropDown from './CSPDropDown'


export type ICspDropDownWrapper = Partial<Omit<IDropDownProps, 'fieldName'>> & {
  curTsgInstCsp: string | undefined
  isLoading: boolean
  tsg: Tsg | undefined
  currentTsg: string
  defaultCSP?: IDropDownData
  lockedInfo?: LockedInfo
  callbacks: IDropDownProps['callbacks']
  supportAccounts: SupportAccount[],
  disable?: boolean,
}

const CSPDropDownWrapper = (props: ICspDropDownWrapper) => {
  const { supportAccounts = [], lockedInfo } = props

  const updatedSupportAccounts = useMemo(() => {
    let filteredSupportAccounts: SupportAccount[]
    // filtering for Fedramp
    // categoryId: 1 - Commercial, 2 - Fedramp Moderate, 3 - Fedramp High
    const isFedModRegionLock = lockedInfo?.regions?.some(region => region === FED_MOD_REGION)
    const isFedHighRegionLock = lockedInfo?.regions?.some(region => region === FED_HIGH_REGION)

    if (!isFedModRegionLock && !isFedHighRegionLock) {
      // if region not fed high or mod, only display commercial accounts
      filteredSupportAccounts = supportAccounts.filter(each => each.supportAccountCategory[0].categoryId === 1)
    }
    else {
      // filter supportAccounts based on locked region
      filteredSupportAccounts = supportAccounts.filter(each => {
        // it should not contain both high and mod
        if (isFedModRegionLock) {
          return each.supportAccountCategory[0].categoryId === 2
        }
        if (isFedHighRegionLock) {
          return each.supportAccountCategory[0].categoryId === 3
        }
        return false
      })
    }
    let lockSupportAccountIdSet: Set<string>
    if (lockedInfo?.support_account_ids) {
      lockSupportAccountIdSet = new Set(lockedInfo?.support_account_ids)
      filteredSupportAccounts = filteredSupportAccounts.filter((each: any) => lockSupportAccountIdSet.has(String(each.accountid)))
    }
    return filteredSupportAccounts
  }, [lockedInfo?.regions, lockedInfo?.support_account_ids, supportAccounts])
  const updatedProps = {
    ...props,
    supportAccounts: updatedSupportAccounts
  }
  return (
    <div><CSPDropDown { ...updatedProps } /> </div>
  )
}

export default CSPDropDownWrapper
